import extractValueFromPriceString from './extractValueFromPriceString';

const isAString = input => typeof input === 'string';
const isANumber = input => typeof input === 'number';
const containsCurrencySymbol = input => input.includes('£');
const onlyNumbers = input => /^\d*\.?\d*$/.test(input);

export default function renderPrice(priceArg) {
  if (
    isAString(priceArg) &&
    !containsCurrencySymbol(priceArg) &&
    !onlyNumbers(priceArg)
  ) {
    return priceArg;
  }

  const priceValue = isANumber(priceArg)
    ? priceArg
    : extractValueFromPriceString(priceArg);

  if (priceValue === null) {
    return '';
  }

  return `${priceValue < 0 ? '-' : ''}£${Math.abs(priceValue).toLocaleString(
    'en',
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  )}`;
}
